import { Avatar, Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import { useNavigate } from "react-router";

import NewDetailCart from "../../TableModal/NewDetailCart";
import CustomCard from "../../CustomCard";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import CustomAvatar from "../../CustomAvatar";
import AvatarList from "../../AvatarList";
import CustomButton from "../../CustomButton";
import useEnroll from "../../../../hooks/UseEnroll";

const NewTableCards = ({ rowData }) => {
  const [enrollBtn, setEnrollBtn] = useState(false);
  const [handleEnrollBtn] = useEnroll(rowData?.pk, enrollBtn, setEnrollBtn);

  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    rowData && setEnrollBtn(rowData.enrolled);
  }, [rowData]);

  const handleGoToTable = (e) => {
    navigate(`/table/${rowData.pk}`);
  };
  return (
    <>
      {rowData.first_post?.post?.first_topic ||
      rowData.first_post?.post?.first_converse ? (
        <CustomCard pSize={16} shadowSize={4} radius={16} mBottom={16}>
          <Box onClick={handleGoToTable}>
            <Typography
              component='h2'
              sx={{
                fontFamily: "Tahrir",
                fontSize: "24px",
                fontWeight: 700,
                mb: "8px",
                // direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
              }}
            >
              {rowData.title}
            </Typography>
            <Box sx={{ display: "flex", position: "relative" }}>
              <Avatar
                src={rowData.banner}
                alt={rowData.title}
                sx={{
                  mx: "2px",
                  my: "4px",
                  width: 90,
                  height: 64,
                  borderRadius: "8px",
                  backgroundColor: "black",
                  boxShadow: `0px 0px 0px ${"2"}px ${theme.palette.black.main}`,
                  zIndex: 1,
                  pointerEvents: "none",
                  mb: "16px",
                  mt: "5px",
                }}
              />
              <Box
                sx={{
                  height: "28px",
                  borderRight: "2px solid",
                  borderColor: "#BDBDBD",
                  position: "absolute",
                  left: "30px",
                  bottom: 0,
                }}
              ></Box>

              <Box sx={{ display: "flex", flexDirection: "column", ml: "8px" }}>
                <AvatarList
                  size={28}
                  avatarData={rowData}
                  type='table'
                  notClick
                />
                <Box sx={{ mt: "auto", mb: "10px" }}>
                  <Typography
                    sx={{ color: "mute.main", fontSize: "12px", pl: "3px" }}
                  >
                    {rowData.category.name}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              borderRadius: "16px",
              border: "2px solid",
              borderColor: theme.palette.whiteDisabled2.main,
              mb: "8px",
            }}
          >
            <NewDetailCart
              type={
                rowData.first_post.post_type === "conversation"
                  ? "discussion"
                  : "opinion"
              }
              rowData={rowData.first_post.post}
              table
            />
          </Box>
          {rowData.last_comment.text && (
            <Box
              onClick={() => navigate(`/table/${rowData.pk}/comment`)}
              sx={{
                border: "2px solid",
                borderColor: "whiteDisabled2.main",
                p: "8px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomAvatar
                //   link={`/profile/${cmData.author.username}`}
                borderSize={2}
                size={"26px"}
                src={rowData.last_comment.author.avatar}
                alt={rowData.last_comment.author.nickname}
              />
              <Typography
                sx={{
                  color: "textField.main",
                  fontSize: "11px",
                  lineHeight: "14px",
                  height: "100%",
                  alignItems: "center",
                  pl: "6px",
                  direction: RightLeftChecker(rowData.last_comment.text)
                    ? "rtl"
                    : "ltr",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {rowData.last_comment.text}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "16px",
            }}
          >
            <Box sx={{ display: "flex", color: "#757575" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <GroupAddOutlinedIcon sx={{ width: "20px" }} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    mt: "auto",
                    mb: "2px",
                    color: "#757575",
                    ml: "3px",
                  }}
                >
                  {rowData.spectators_count}
                </Typography>
              </Box>
              <Box
                onClick={() => navigate(`/table/${rowData.pk}/comment`)}
                sx={{ display: "flex", alignItems: "center", ml: "20px" }}
              >
                <TextsmsOutlinedIcon sx={{ width: "20px", mt: "4px" }} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    mt: "auto",
                    mb: "2px",
                    color: "#757575",
                    ml: "3px",
                  }}
                >
                  {rowData.all_comments_count}
                </Typography>
              </Box>
            </Box>
            <CustomButton
              title={enrollBtn ? "Followed" : "Follow"}
              onClick={() => handleEnrollBtn()}
              fSize='12px'
              width='68px'
              height='32px'
              bShadow='2px'
              color={enrollBtn ? "white.main" : "black.main"}
              bgColor={enrollBtn ? "black.main" : "primary.main"}
            />
          </Box>
        </CustomCard>
      ) : null}
    </>
  );
};
export default NewTableCards;
